import Vue from 'vue';
import Vuex from 'vuex';

import pogaCustomReport from './modules/pogaCustomReport';
import contactsReports from './modules/contactsReports';
import logsReports from './modules/logsReports';
import accounts from './modules/accounts';
import blockList from './modules/blockList';
import agentBots from './modules/agentBots';
import agents from './modules/agents';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auth from './modules/auth';
import auditlogs from './modules/auditlogs';
import automations from './modules/automations';
import bulkActions from './modules/bulkActions';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import csat from './modules/csat';
import customViews from './modules/customViews';
import dashboardApps from './modules/dashboardApps';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import labels from './modules/labels';
import macros from './modules/macros';
import notifications from './modules/notifications';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';

import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';

import roles from './modules/roles';
import cannedFile from './modules/cannedFile';
import workflows from './modules/workflows';
import closingNote from './modules/closingNote';
// New
import conversationLogs from './modules/conversationLogs';
import reportsConversation from './modules/reportsConversation';
import agentLogs from './modules/agentLogs';
import agentSessionLogs from './modules/agentSessionLogs';
import IncomingMessageList from './modules/reports/message/IncomingMessageList';
import outGoinigMessageList from './modules/reports/message/outGoinigMessageList';
import metricsMessages from './modules/reports/message/metricsMessages';
import failedMessageList from './modules/reports/message/failedMessageList';
import newCampaign from './modules/campaign/newCampaign';
import inboxTeams from './modules/inboxTeams';
import salla from './modules/salla';
import zid from './modules/zid';
import subscription from './modules/subscription';
import bevaAI from './modules/bevaAI';
import facebookPages from './modules/facebookPages';
import uiChanges from './modules/uiChanges';
import zoho from './modules/zoho';

const plugins = [];

// Broadcast
import broadcastCampaigns from './modules/broadcast/broadcastCampaigns';
import broadcastReport from './modules/broadcast/broadcastReport';
import templates from './modules/workflowTemplates/templates';

if (window.logRocketProjectId) {
  LogRocket.init(window.logRocketProjectId);
  const logRocketPlugin = createPlugin(LogRocket, function (mutation) {
    const eventsToIgnore = ['SET_CURRENT_USER', 'AUTHENTICATE', 'CLEAR_USER'];
    if (eventsToIgnore.includes(mutation.type)) {
      return null;
    }

    return mutation;
  });

  plugins.push(logRocketPlugin);
}

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    accounts,
    pogaCustomReport,
    contactsReports,
    logsReports,
    agentBots,
    blockList,
    agents,
    articles,
    attributes,
    auth,
    automations,
    auditlogs,
    bulkActions,
    campaigns,
    cannedResponse,
    categories,
    contactConversations,
    contactLabels,
    contactNotes,
    contacts,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationWatchers,
    csat,
    customViews,
    dashboardApps,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    integrations,
    labels,
    macros,
    notifications,
    portals,
    reports,
    teamMembers,
    teams,
    userNotificationSettings,
    webhooks,
    cannedFile,
    roles,
    workflows,
    closingNote,
    conversationLogs,
    reportsConversation,
    agentLogs,
    agentSessionLogs,
    broadcastCampaigns,
    broadcastReport,
    IncomingMessageList,
    outGoinigMessageList,
    metricsMessages,
    failedMessageList,
    newCampaign,
    inboxTeams,
    salla,
    zid,
    subscription,
    bevaAI,
    templates,
    facebookPages,
    uiChanges,
    zoho,
  },
  plugins,
});
